import { authService } from '@/api';
import { Button, Typography } from '@/components/common';
import { InputEmail } from '@/components/form';
import { useNotification } from '@/hooks';
import { formatErrorMessage } from '@/lib';
import * as React from 'react';
import { FieldValues, useForm } from 'react-hook-form';

interface VerifyEmailErrorProps {
	type?: 'reactivate' | 'signin';
}

export const VerifyEmailError: React.FC<VerifyEmailErrorProps> = ({ type }) => {
	const rules = {
		email: {
			required: { value: true, message: 'This is required.' },
		},
	};

	const { toastSuccess, toastError } = useNotification();
	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const {
		register,
		handleSubmit,
		setValue,
		formState: { errors, isDirty, isValid },
	} = useForm({ mode: 'onSubmit' });

	const handleSubmitData = async (values: FieldValues): Promise<void> => {
		setIsLoading(true);
		try {
			if (type && type === 'reactivate') {
				await authService.resendRecoverAccountEmail(values.email);
			} else {
				await authService.resendVerificationEmail(values.email);
			}
			toastSuccess('Verification email has been successfully sent.');
		} catch (error) {
			toastError(formatErrorMessage((error as any).message));
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<>
			<Typography
				type="regular-18"
				className="text-center text-opacity-black mb-10"
			>
				{`It looks like the verification link has expired. Don’t worry; you can`}
				<br />
				request a new one to verify your email address.
			</Typography>
			<form
				className="w-full space-y-8"
				onSubmit={handleSubmit(handleSubmitData)}
			>
				<InputEmail
					dataCY="email"
					name="email"
					title="Email"
					register={register}
					rules={rules.email}
					error={errors.email}
					className="bg-white"
					setValueCustom={setValue}
				/>
				<Button
					dataCY="signin"
					type="submit"
					size="full"
					decoration="primary"
					label="Request New Link"
					loading={isLoading}
					disabled={isLoading || !isDirty || !isValid}
					className="!w-[300px] !h-16 mx-auto"
				/>
			</form>
		</>
	);
};
